<!-- this component is deprecated -->
<template>
  <b-container v-if="!isLoggedIn()" class="loginFormContainer" style="height:100%;padding:10px;">
    <b-row align-v="center" style="height:100%;">
      <b-col style="height:200px;">
        <b-row>
          <b-col cols="12">
            <OpaInputText type="text" v-model="email" placeholder="E-Mail" :required="true" :icon="['fal', 'envelope']"/>
          </b-col>
          <b-col cols="12">
            <OpaInputText type="password" @inputEnter="() => doLogin()" v-model="password" placeholder="Senha" :required="true" :icon="['fal', 'key']"/>
          </b-col>
          <b-col cols="12">
            <div @click="doLogin()" :style="{backgroundColor: getCssColor('primary_bt')}"
              style="margin-top:20px;color:#ffffff; cursor:pointer; font-size:14px; font-weight:500; border-radius:4px; height:40px;line-height:40px;text-align:center;">
              ENTRAR
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
  <b-container v-else style="width:100%; height:100%;padding:10px;">
    <b-row align-v="center" style="height:100%;">
      <b-col>
        <b-row>
          <b-col cols="12">
            <OpaInputText type="text" v-model="$store.state.user.name" placeholder="Usuário" :icon="['fal', 'user']" :disabled="true"/>
          </b-col>
          <b-col cols="12">
            <OpaInputText type="text" v-model="$store.state.user.email" placeholder="E-Mail" :icon="['fal', 'envelope']" :disabled="true"/>
          </b-col>
          <b-col cols="12">
            <div @click="doLogout()" :style="{backgroundColor: getCssColor('secondary_bt')}"
              style="margin-top:40px;color:#ffffff; cursor:pointer; font-size:14px; font-weight:500; border-radius:4px; height:40px;line-height:40px;text-align:center;">
              SAIR
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import OpaInputText from '@/components/OpaInputText'
import UserConn from '@/connection/user'
import colors from '@/mixins/colors'
import { EventBus } from '@/behaviours/event-bus'

export default {
  data () {
    return {
      email: null,
      password: null
    }
  },

  mixins: [colors],

  components: {OpaInputText},

  methods: {
    isLoggedIn () {
      return UserConn.isLoggedIn()
    },

    doLogout () {
      UserConn.logout()
      this.$store.state.choicedCompanyId = null
      this.$store.state.choicedCompany = null
      this.$store.state.selectedAddressShort = null
      location.reload()
    },

    async doLogin() {
      if (this.email && this.password) {
        this.$store.state.showLoading = true
        let result = await UserConn.doLogin(this.email, this.password)
        console.log(result)
        if (result.error && result.error === 'user not verified') {
          localStorage.setItem('tempMail', this.email.trim())
          localStorage.setItem('tempPass', this.password)
          this.$router.push({path: '/validation'})
        } else if (result.error) {
          this.$store.state.showLoading = false
          EventBus.$emit('showAlert', 'error', 'Usuário e/ou senha inválidos')
        } else {
          localStorage.setItem('tempMail', null)
          localStorage.setItem('tempPass', null)
          if (this.$store.state.registerLoginOrigin === 'cart'){
            this.$router.push({path: '/cart'})
          } else if (this.$store.state.registerLoginOrigin === 'history'){
            this.$router.push({path: '/history'})
          } else if (this.$store.state.registerLoginOrigin === 'offers'){
            this.$router.push({path: '/offers'})
          } else if (this.$store.state.registerLoginOrigin === 'stay'){
            // stay in view and emit the login
            this.$emit('loggedIn')
            this.$store.state.showLoading = false
          } else {
            // TODO check if need auto address here
            console.log('REdirect from login header')
            this.$router.push({path: '/home'})
          }
        }
        
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/css/_variables.scss";
.loginFormContainer {
  width:100%;
  max-width: $mobile;
}
</style>
